const NOTIFICATION_TEST_AND_PREVIEW_TYPES = Object.freeze({
  TEST_ALARM_MODEL: 1,
  TEST_SYNTH_ALARM_MODEL: 2,
  TEST_NMS_ALARM_MODEL: 3,
  TEST_INSIGHT_ALARM_MODEL: 4,
  TEST_MITIGATION_ALARM_MODEL: 5
});

const CHANNEL_TYPES = Object.freeze({
  XMATTERS: 'xmatters',
  SLACK: 'slack',
  SERVICENOW: 'servicenow',
  SYSLOG: 'syslog',
  OPSGENIE: 'opsgenie',
  CUSTOM_WEBHOOK: 'custom-webhook',
  SPLUNK: 'splunk',
  MSTEAMS: 'msteams',
  JSON: 'json',
  EMAIL: 'email',
  VICTOROPS: 'victorops',
  PAGERDUTY: 'pagerduty'
});

const OAUTH2_FIELD_IDENTIFIERS = [
  'config.sendingConfig.oauth2AccessTokenURL',
  'config.sendingConfig.oauth2TlsVerify',
  'config.sendingConfig.oauth2TlsPem',
  'config.sendingConfig.oauth2TlsClientCertPem',
  'config.sendingConfig.oauth2TlsClientKeyPem',
  'config.sendingConfig.oauth2ClientId',
  'config.sendingConfig.oauth2ClientSecret',
  'config.sendingConfig.oauth2Scopes'
];

module.exports = {
  CHANNEL_TYPES,
  OAUTH2_FIELD_IDENTIFIERS,
  NOTIFICATION_TEST_AND_PREVIEW_TYPES
};
